/**
 * 路由配置文件
 */
import { flatten } from 'lodash'
import { I18N_KEY } from '@/app/util'
class RouteModal {
  constructor(lang) {
    const loginCom = () => import('../pages/login/index')
    const homeCom = () => import('../pages/homePages/index')
    const userCom = () => import('../pages/userSetting/index')
    const routes = [
      {
        name: 'login',
        component: loginCom // 登录
      },
      {
        name: 'forget',
        component: loginCom // 忘记密码
      },
      {
        name: 'regit',
        component: loginCom // 忘记密码
      },
      {
        name: 'WarrantySearch',
        component: homeCom // WarrantySearch
      },
      {
        name: 'WarrantyExtenish',
        component: homeCom // WarrantyExtenish
      },
      {
        name: 'WarrantyActivation',
        component: homeCom // WarrantyActivation
      },
      {
        name: 'Emailsetting',
        newpath: 'userSetting/Emailsetting',
        component: userCom // Emailsetting
      },
      {
        name: 'Accountsetting',
        newpath: 'userSetting/Accountsetting',
        component: userCom // Accountsetting
      },
      {
        name: 'Ordermanagement',
        newpath: 'userSetting/Ordermanagement',
        component: userCom // Ordermanagement
      },
      {
        name: 'Passwordsetting',
        newpath: 'userSetting/Passwordsetting',
        component: userCom // Passwordsetting
      }
    ].map(item => {
      return {
        isCache: false,
        permission: 'all',
        route: {
          path: item.newpath ? `/${lang}/${item.newpath}` : `/${lang}/${item.name}`,
          meta: {
            lang: lang
          },
          ...item
        }
      }
    })
    return routes;
  }
}
export default function () {
  const routers = I18N_KEY.map(item => {
    return new RouteModal(item)
  })
  return [{
    permission: 'all',
    route: {
      path: '/',
      name: '/',
      meta: [],
      component: () => import('../pages/nil/index')
    }
  }, ...flatten(routers)]
}



// WEBPACK FOOTER //
// ./src/app/sitmap.js